import { ChangeDetectionStrategy, Component, Input, OnInit, Output } from '@angular/core';
import { SharedService } from '@core/services/shared.service';
import { FacilityListModel, FacilityListOptsModel } from '@shared/models/facility.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-facilities-list',
  templateUrl: './facilities-list.component.html',
  styleUrls: ['./facilities-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacilitiesListComponent implements OnInit {

  @Output() selectedFacility: Subject<any> = new Subject<any>();
  @Input() opts: FacilityListOptsModel;
  facilitiesList: FacilityListModel[];
  selectedValue: string;

  constructor(public sharedService: SharedService) { }

  /**
   * init
   */
  ngOnInit(): void {

    // eğer ki seçili tesis yosa ilk tesisi seçiyoruz.
    if (!this.sharedService?.preferences?.selectedFacility) {
      this.sharedService.facilitiesList$.subscribe((facilities: any) => {
        this.selectedValue = facilities[0];
        this.sharedService.setPreferences('selectedFacility', facilities[0]);
      });
    }

    this.selectedValue = this.opts?.selectedItem || this.sharedService?.preferences?.selectedFacility;
  }

  /**
   * tesis seçiminde yapılacak işlemler.
   * @param {object} val
   */
  setFacility(val: object): void {
    this.sharedService.setPreferences('selectedFacility', val);
    this.selectedFacility.next(val);
  }

  /**
   * karşılaştırma
   * @param o1
   * @param o2
   */
  compareNzFn = (o1: any, o2: any) => (o1 && o2 ? o1.facilityId === o2.facilityId : o1 === o2);
}
